











import { Component, Vue } from 'vue-property-decorator';
import Deck from '@/components/Deck.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    Deck,
    Button,
  },
})
export default class Decks extends Vue {
  get decks() {
    return this.$store.state.decks;
  }

  private addNewDeck() {
    this.$router.push({
      name: 'newDeck',
    });
  }
}
